export const ADD_TOTAL = "Add Total";
